export default "__VITE_ASSET__5ceaceb3__"